import { Component, OnInit, ViewEncapsulation, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LanguageService } from '../language/language.service';
import { ToastService } from '../toast/toast.service';
import { ModalService } from './modal.service';

const KEY_ESC = 27;

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class ModalComponent implements OnInit, OnDestroy {
    @Input() name;
    visible: boolean = false;
    public title: string;
    public message: string;
    okText: string;
    cancelText: string;
    copyLinkText: string;
    showCopyButton: boolean;
    negativeOnClick: (e: any) => boolean;
    positiveOnClick: (e: any) => boolean;
    subscription: Subscription;

    private defaults = {
        title: 'confirmation',
        message: 'Do you want to cancel your changes?',
        cancelText: 'cancel',
        okText: 'confirm',
        showCopyButton: false
    };
    private modalElement: any;
    private cancelButton: any;
    private okButton: any;

    constructor(private _modalService: ModalService, private _toastService: ToastService, private _languageService: LanguageService) {
        _modalService.activate = this.activate.bind(this);
    }

    ngOnInit() {
        this.modalElement = document.getElementById('confirmationModal');
        this.cancelButton = document.getElementById('cancelButton');
        this.okButton = document.getElementById('okButton');
    }

    activate(message = this.defaults.message, title = this.defaults.title, okText = this.defaults.okText, cancelText = this.defaults.cancelText, showCopyButton = this.defaults.showCopyButton): Promise<boolean> {
        this.title = title;
        this.message = message;
        this.okText = okText;
        this.cancelText = cancelText;
        this.copyLinkText = this._languageService.translate("kopiraj_link");
        this.showCopyButton = showCopyButton;

        let promise = new Promise<boolean>((resolve, reject) => {
            this.negativeOnClick = (e: any) => {
                resolve(false);
                return false;
            }
            this.positiveOnClick = (e: any) => {
                resolve(true);
                return true;
            }
            this.show();
        });

        return promise;
    }

    ngOnDestroy() {
        // prevent memory leak when component destroyed
        this.subscription.unsubscribe();
    }

    private show() {
        document.onkeyup = null;

        if (!this.modalElement || !this.cancelButton || !this.okButton) {
            return;
        }

        this.cancelButton.onclick = ((e: any) => {
            e.preventDefault();
            if (!this.negativeOnClick(e))
                this.hideDialog();
        });

        this.okButton.onclick = ((e: any) => {
            e.preventDefault();
            this.positiveOnClick(e);

            this.hideDialog();
        });

        this.modalElement.onclick = () => {
            //this.hideDialog();
            return this.negativeOnClick(null);
        };

        document.onkeyup = (e: any) => {
            if (e.which == KEY_ESC)
                this.hideDialog();
        };

        document.getElementById("openModalButton").click();
    }

    private hideDialog() {
        document.getElementById("cancelButton").click();
    }

    public copyLink() {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = this.message;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);

        this._toastService.activate(this._languageService.translate("link_ankete_kopiran"), "alert-successToast");
    }
}
